import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Your luck & opportunity surface area",
  "description": "Here's a comment that resonated yesterday and you might like. It's about how to maximize the opportunity in your work.",
  "published": "2021-03-26T00:00:00.000Z",
  "categories": "Lessons, Mindset, Senior",
  "content_upgrade": "SeniorMindset",
  "hero": "./img/Luck-surface-areab637ca.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`here's a comment that resonated yesterday and you might like. It's about how to maximize the opportunity in your work.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Do you spend your time marketing your self to others and letting people know your accomplishments, or do you spend the time doing work that will benefit others?`}</p>
    </blockquote>
    <p>{`I like the luck surface area analogy for this.`}</p>
    <p>{`Take a rectangle. Side A is "Quality of work". Side B is "How many people know about it". The surface area – A`}{`*`}{`B – is your luck and opportunity.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/4429e3542a4a35f6381c733573ffbb65/a95f7/Luck-surface-areab637ca.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "77.57847533632287%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'311\\'%20viewBox=\\'0%200%20400%20311\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M72%206l-1%2014-1%2053v42H44l13%201%2013%201-1%2045v67l-1%2022H49l9%201h9v6l1%205%201-5%201-5c3-2%2036-2%2055%200l112%201h92v10l1%2010v-20h3a242%20242%200%200142%204c-1-3-20-6-43-6-3%200-5-41-4-90l1-41v-4h14l20%201a337%20337%200%2000-33-3c-1-1-1-5%201-31v-3l-1%204-1%2017-1%2013h-34a3177%203177%200%2001-188%200H71l1-33a1516%201516%200%20010-76m7%20110l-7%201-1%2054a2002%202002%200%2001-1%2079h44a973%20973%200%2000130%203l43-1h42v-6c0-6%200-7-2-7v-27a393%20393%200%20010-64l1-31h-4a612%20612%200%2000-76%201%2025984%2025984%200%2000-90-1c2-2-58-3-79-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4429e3542a4a35f6381c733573ffbb65/ca0a1/Luck-surface-areab637ca.webp 223w", "/static/4429e3542a4a35f6381c733573ffbb65/75680/Luck-surface-areab637ca.webp 445w", "/static/4429e3542a4a35f6381c733573ffbb65/8d1ba/Luck-surface-areab637ca.webp 890w", "/static/4429e3542a4a35f6381c733573ffbb65/3838e/Luck-surface-areab637ca.webp 1335w", "/static/4429e3542a4a35f6381c733573ffbb65/e11e5/Luck-surface-areab637ca.webp 1780w", "/static/4429e3542a4a35f6381c733573ffbb65/4ae83/Luck-surface-areab637ca.webp 1853w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4429e3542a4a35f6381c733573ffbb65/e92b6/Luck-surface-areab637ca.png 223w", "/static/4429e3542a4a35f6381c733573ffbb65/e66bf/Luck-surface-areab637ca.png 445w", "/static/4429e3542a4a35f6381c733573ffbb65/4ef49/Luck-surface-areab637ca.png 890w", "/static/4429e3542a4a35f6381c733573ffbb65/4e814/Luck-surface-areab637ca.png 1335w", "/static/4429e3542a4a35f6381c733573ffbb65/701e9/Luck-surface-areab637ca.png 1780w", "/static/4429e3542a4a35f6381c733573ffbb65/a95f7/Luck-surface-areab637ca.png 1853w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/4429e3542a4a35f6381c733573ffbb65/4ef49/Luck-surface-areab637ca.png",
                "alt": "Luck surface area",
                "title": "Luck surface area",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Luck surface area`}</figcaption>{`
  `}</figure></p>
    <p>{`If you do amazing work and nobody knows about it, your luck is zero.`}</p>
    <p>{`If you do terrible work and everyone knows about it, your luck is zero.`}</p>
    <p>{`A square would be equal balance of A and B, which is okay but not to everyone's liking. You can get the same surface area with 2A and 0.5B. You can get a huge surface area with 2A and 1B.`}</p>
    <p>{`For engineer types, optimizing for big A and just enough B is easiest. We tend to err on the side of not enough B.`}</p>
    <p><a parentName="p" {...{
        "href": "https://news.ycombinator.com/item?id=26583526"
      }}>{`Discussion in replies`}</a>{` had some good ideas. Like expanding the rectangle into a cube.`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      